import { Link, Outlet, useNavigate } from "react-router-dom";
import {
  Typography,
  Container,
  TextField,
  Switch,
  InputAdornment,
  InputLabel,
  FormControl,
  OutlinedInput,
  IconButton,
  Box,
  Toolbar,
  AppBar,
  Tabs,
  Tab,
  Dialog,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import { FiChevronRight } from "react-icons/fi";
import you from "../../assets/images/profilephoto.png";
import proifleimg from "../../assets/images/proifleimg.png";
import carpark from "../../assets/images/car-parking.svg";
import Logout from "../../assets/images/logout.svg";
import tabhome from "../../assets/images/tabhome.svg";
import edit from "../../assets/images/edit.svg";
import account from "../../assets/images/account.svg";
import support from "../../assets/images/support.svg";
import applepay from "../../assets/images/applepay.svg";
import requestcall from "../../assets/images/requestcall.svg";
import supportchat from "../../assets/images/supportchat.svg";
import Loginimage from "../../assets/images/succcess.svg";
import { FaCalendarAlt, FaParking, FaCreditCard, FaPencilAlt, FaTrash, FaPhoneAlt } from "react-icons/fa";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { BsHouseDoor, BsClockHistory, BsPerson, BsHeadset, BsChatDots } from "react-icons/bs";
import { Button, ButtonGroup, Card, Col, Form, Modal, Row } from "react-bootstrap";
import WebService from "../../Services/WebService";

const Profile = () => {
  const [open, setOpen] = useState(false);
  const [UserData, setUserData] = useState<any>({});

  const handleClickOpen = () => {
    setOpen(true);
  };
  const navigate = useNavigate();
  const [autoStart, setAutoStart] = useState(true);
  const [autoExtend, setAutoExtend] = useState(true);
  const [maxPayment, setMaxPayment] = useState(false);
  const [AccountDetailData, setAccountDetailData] = useState<any>({});
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    const savedUserData = localStorage.getItem("user_data");
    console.log("savedUserData");

    if (savedUserData) {
      setUserData(JSON.parse(savedUserData));
      console.log("JSON.parse(savedUserData)", JSON.parse(savedUserData));
    }
  }, []);

  const handleLogout = () => {
    navigate("/login");

    localStorage.clear();
  };

  const getAccouDetails = () => {
    WebService.getAPI({
      action: "/api/Account/Details",
    })
      .then((res) => {
        setAccountDetailData(res);
      })
      .catch(() => {});
  };

  return (
    <>
      <Container>
        <div className="app-container">
          {/* Sticky Header */}
          <header className="header text-white text-center d-flex justify-content-between align-items-center">
            <div>Account</div>
            <div className=" visablityhidden">
              <button className="back-button">&nbsp;&nbsp;&nbsp;&nbsp;</button>{" "}
            </div>
          </header>
          <Container className="mt-3 px-3 pagewrap">
            {/* Profile Card */}
            <Card className="text-center p-3 shadow-sm border-0 text-center">
              <Link to="/editprofile">
                <Button variant="light" className="btn-sm border editprofile border-0 rounded-2 py-1 px-3">
                  {" "}
                  <img src={edit} width="14" height={14} alt="Logo" />
                  &nbsp;&nbsp;EDIT
                </Button>
              </Link>
              <img
                src={you}
                width="100"
                height={100}
                alt="Logo"
                style={{ margin: "0 auto;" }}
                className="mx-auto"
              />

              <h5 className="mt-2 font-16">{UserData.EmailAddress}</h5>
              <p className="font-16">{UserData.PhoneNumber}</p>
            </Card>

            {/* Default Parking Options */}
            <Card className="mt-4 border-0 shadow-sm mb-4">
              <div className="card-header pt-3 bg-white">
                <h5 className="font-bold" style={{ fontSize: "17px" }}>
                  Default Parking Options
                </h5>
              </div>
              <div className="card-body">
                <div className="d-flex justify-content-between mb-4">
                  <div>Auto Start Parking Session</div>
                  <div>
                    {" "}
                    <Form.Check
                      type="switch"
                      checked={autoStart}
                      className="radiobutons"
                      onChange={() => setAutoStart(!autoStart)}
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-between mb-4" style={{ color: "#222" }}>
                  <div>Auto Extend Parking Session</div>
                  <div>
                    {" "}
                    <Form.Check
                      type="switch"
                      checked={autoStart}
                      className="radiobutons"
                      onChange={() => setAutoExtend(!autoExtend)}
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-between mb-0">
                  <div>Max Payment Amount</div>
                  <div>
                    {" "}
                    <Form.Check
                      type="switch"
                      checked={autoStart}
                      className="radiobutons"
                      onChange={() => setAutoStart(!autoStart)}
                    />
                  </div>
                </div>
              </div>
            </Card>

            {/* My Vehicles */}
            <Link to="/myvehicles">
              <Card className="support-card mt-3  shadow-sm border-0">
                <Card.Body className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <h5 className="font-bold" style={{ fontSize: "17px" }}>
                      My Vehicles
                    </h5>
                    {/* <span className="ms-0 font-bold">My Vehicles</span> */}
                  </div>
                  <FiChevronRight size={20} />
                </Card.Body>
              </Card>
            </Link>

            {/* Logout Button */}
            <div className="text-center mt-4">
              <Button variant="white" className="w-100 text-danger font-bold" onClick={handleClickOpen}>
                Logout
              </Button>
            </div>
          </Container>

          {/* Bottom Navigation */}
          <nav className="bottom-nav d-flex justify-content-around align-items-center py-2">
            <div className="nav-item ">
              <Link to="/homepage">
                <img src={tabhome} alt="Parking Spot" className="rounded" style={{ width: "24px" }} />
                <br></br>
                <span>Home</span>
              </Link>
            </div>
            <div className="nav-item ">
              <Link to="/pastpark">
                <img src={carpark} alt="Parking Spot" className="rounded" style={{ width: "24px" }} />
                <br></br>
                <span>Past Parkings</span>
              </Link>
            </div>
            <div className="nav-item ">
              <Link to="/account">
                <img src={account} alt="Parking Spot" className="rounded" style={{ width: "24px" }} />
                <br></br>
                <span>Account</span>
              </Link>
            </div>
            <div className="nav-item ">
              <Link to="/supportpage">
                <img src={support} alt="Parking Spot" className="rounded" style={{ width: "24px" }} />
                <br></br>
                <span>Support</span>
              </Link>
            </div>
            <div className="nav-item active profile">
              <Link to="/profile">
                <img src={proifleimg} alt="Profile" className="rounded-circle" />
                <br></br>
                <span>Profile</span>
              </Link>
            </div>
          </nav>

          <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>Sort</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="list-group">
                <label className="d-flex align-items-center mb-3">
                  <input type="radio" name="sort" className="form-check-input me-2" />
                  <span>Newest</span>
                </label>
                <label className="d-flex align-items-center mb-3">
                  <input type="radio" name="sort" className="form-check-input me-2" />
                  <span>Oldest</span>
                </label>
                <label className="d-flex align-items-center mb-3">
                  <input type="radio" name="sort" className="form-check-input me-2" />
                  <span>Less Distance</span>
                </label>
                <label className="d-flex align-items-center">
                  <input type="radio" name="sort" className="form-check-input me-2" />
                  <span>More Distance</span>
                </label>
              </div>
            </Modal.Body>
            <Modal.Footer className="d-flex p-3">
              <Button className="w-50 btn-light">Reset Filter</Button>
              <Button className="w-50 btn-brand-1 font-bold">Apply</Button>
            </Modal.Footer>
          </Modal>
        </div>

        <React.Fragment>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description" className="text-center">
                <img src={Logout} width="78" height={78} alt="Logo" />
                <br></br>
                <h5 className="text-dark mt-3 font-bold">Logout?</h5>
                Are you sure you want to logout?
              </DialogContentText>
              <Modal.Footer className="d-flex p-0 mt-3">
                {/* <Link to="/login"> */}
                <Button
                  className="btn-light me-2 font-bold"
                  style={{ width: "120px!important" }}
                  onClick={() => handleLogout()}
                >
                  Yes, Logout
                </Button>
                {/* </Link> */}
                <Button className="w-50 btn-brand-1 font-bold">No</Button>
              </Modal.Footer>
            </DialogContent>
          </Dialog>
        </React.Fragment>
      </Container>
    </>
  );
};

export default Profile;
